import { getEmailDomain } from "../../../../../actions/Utilities/EmailDomain";
import { useQuery } from "react-query";

export default function useGetEmailDomains() {
  return useQuery("GetEmailDomains", getEmailDomain, {
    refetchOnWindowFocus: false,
  });
}